export const lg_footer_userrequest = {
  lg_footer_userrequest_th: {
    title: "กรุณากรอกข้อมูล",
    name: "ชื่อ",
    placeholdername: "ชื่อ",
    email: "อีเมล์",
    placeholderemail: "อีเมล์",
    phonenumber: "เบอร์โทรศัพท์",
    placeholderphonenumber: "เบอร์โทรศัพท์",
    subject: "หัวข้อ",
    placeholderphonesubject: "หัวข้อ",
    message: "ข้อความ",
    placeholdermessage: "กรุณาเขียนรายระเอียดการขอใช้สิทธิ",
    buttonsend: "ส่ง",
    manageyourdatarights:"จัดการสิทธิ์ข้อมูลของคุณ",
    submanageyourdatarights:"ควบคุมข้อมูลส่วนบุคคลของคุณได้ง่าย ๆ ด้วยแบบฟอร์มของเรา",
    personalinformation:"ข้อมูลส่วนตัว",
    submit:"ส่ง",
    detailsofyourrequest:"รายละเอียดคำขอของคุณ",
    phone_hint: "ตัวอย่าง: +123456789",
    email_hint:"เราจะไม่แบ่งปันอีเมลของคุณให้กับผู้อื่น",
    selectyourrequest:"เลือกคำขอของคุณ",
    Access_information : "เข้าถึงข้อมูล",
    Update_Information : "อัปเดตข้อมูล",
    Delete_Account : "ลบบัญชี",
    check_details: "ตรวจสอบรายละเอียด",
    check_details_sub: "ตรวจสอบรายละเอียดของคุณก่อนส่ง",
    check_details_email: "ตรวจสอบอีเมลของคุณก่อนส่ง",
    detail_first_submit:"ในการคลิก ส่ง คุณยืนยันว่าข้อมูลที่ให้มานั้นถูกต้อง"
  },
  lg_footer_userrequest_en: {
    title: "Please fill out",
    name: "Name",
    placeholdername: "Name",
    email: "Email",
    placeholderemail: "Email",
    phonenumber: "Phone Number",
    placeholderphonenumber: "Phone Number",
    subject: "Subject",
    placeholdersubject: "Subject",
    message: "Message",
    placeholdermessage: "Please explain the reason(s) for permission request.",
    buttonsend: "Send",
    manageyourdatarights:"Manage Your Data Rights",
    submanageyourdatarights:"Take control of your personal data with our simple form.",
    personalinformation:"Personal Information",
    submit:"Submit",
    detailsofyourrequest:"Details of Your Request",
    phone_hint: "Example: +123456789",
    email_hint:"We'll never share your email with anyone else.",
    selectyourrequest:"Select Your Request",
    Access_information : "Access information",
    Update_Information : "Update Information",
    Delete_Account : "Delete Account",
    check_details: "Check Details",
    check_details_sub: "Please check your details before submitting.",
    check_details_email: "Check your email before submitting.",
    detail_first_submit: "By clicking submit, you confirm the information provided is accurate"
    
  },
};
